import React from 'react';
import { brandName, contactEmail, heroHeading, heroSubtext } from '../content/home';
import '../styles/global.css';
import '../styles/layout.css';
import '../styles/components.css';

const HomeLanding: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 60%)',
      }}
    >
      {/* Simple, elegant header */}
      <header
        style={{
          padding: '18px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'transparent',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 28, height: 28, borderRadius: 8, background: 'var(--color-text-primary)' }} />
          <strong style={{ fontSize: 18, color: '#0f172a', letterSpacing: 0.2 }}>{brandName}</strong>
        </div>
        
      </header>

      {/* Hero */}
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <section
          style={{
            width: '100%',
            maxWidth: 880,
            textAlign: 'center',
            padding: '40px 20px',
          }}
        >
          <h1
            style={{
              fontSize: 56,
              lineHeight: 1.05,
              marginBottom: 10,
              color: '#0b1020',
              fontWeight: 800,
              letterSpacing: -0.5,
            }}
          >
            {heroHeading}
          </h1>
          {(() => {
            const lines = (heroSubtext || '').split('\n');
            const first = lines[0] || '';
            const rest = lines.slice(1).join('\n');
            return (
              <>
                <div style={{ color: 'var(--color-text-primary)', fontSize: 26, fontWeight: 600, marginBottom: 12 }}>
                  {first}
                </div>
                {rest && (
                  <p style={{ color: '#334155', margin: '0 auto 28px', maxWidth: 720, fontSize: 18, whiteSpace: 'pre-line' }}>
                    {rest}
                  </p>
                )}
              </>
            );
          })()}
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href={`mailto:${contactEmail}`}
              style={{
                padding: '12px 18px',
                background: 'var(--color-text-primary)',
                color: 'var(--color-text-inverse)',
                borderRadius: 10,
                textDecoration: 'none',
                boxShadow: '0 2px 10px rgba(17,24,39,0.08)',
              }}
            >
              Get in touch
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomeLanding;
